import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { cn } from "../lib/utils";

export function FullScreenModal({
  onClose,
  children,
  testid,
  contentClassName = "",
  overlayClassName = "",
  ariaLabel = "Dialog",
  contentRef,
}) {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  const overlay = (
    <div
      className={cn(
        "fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-2 sm:p-4 md:p-6",
        overlayClassName,
      )}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel}
      data-testid={testid}
    >
      <div
        ref={contentRef}
        className={cn(
          "w-full max-w-lg rounded-[var(--t-event-pill-radius)] border border-[var(--t-border)] bg-[var(--t-bg)] p-8",
          contentClassName,
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );

  return createPortal(overlay, document.body);
}

